import { render, staticRenderFns } from "./PollCard.vue?vue&type=template&id=d8789d34&scoped=true&"
import script from "./PollCard.vue?vue&type=script&lang=js&"
export * from "./PollCard.vue?vue&type=script&lang=js&"
import style0 from "./PollCard.vue?vue&type=style&index=0&id=d8789d34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8789d34",
  null
  
)

export default component.exports